import axios from 'axios';

// Cliente HTTP único da aplicação. Antes havia três instâncias com baseURL
// divergente (fallback em :3000, em :4000 e sem fallback), e só uma delas
// registrava o interceptor de 401 — as páginas admin ficavam sem ele.
// AuthContext e api/events.ts reexportam esta instância.
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api/v1',
  withCredentials: true,
});

export default api;
